var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NotificationUtils } from '@yodlee/common-components/dist/utilities';
import { Col, Icon, Row, Spin } from 'antd';
import { cloneDeep, findIndex, sortBy } from "lodash";
import React, { useEffect, useRef, useState } from 'react';
import { AmplitudeEventsUtils, DataUtils, RoleGroupUtils } from '../../utilities';
import Roles from "./roles";
import RolePermissions from "./roles-permissions";
import RoleUsers from "./roles-users";
var breakpoints = {
    xxl: { span: 8 },
    xl: { span: 8 },
    lg: { span: 8 },
    md: { span: 24 },
    sm: { span: 24 }
};
function convertArrayToObject(array, key) {
    if (!array || !Array.isArray(array))
        return {};
    var initialValue = {};
    return array.reduce(function (obj, item) {
        var _a;
        return __assign(__assign({}, obj), (_a = {}, _a[item[key]] = item, _a));
    }, initialValue);
}
;
var processStaticPermissions = function (permissions) {
    var formattedPermissions = [];
    permissions.forEach(function (perm) {
        var subPermissions = (perm === null || perm === void 0 ? void 0 : perm.subPermissions) || [];
        if (subPermissions.length > 0) {
            subPermissions.forEach(function (subPerm) {
                var subSubPermission = (subPerm === null || subPerm === void 0 ? void 0 : subPerm.subPermissions) || [];
                if (subSubPermission.length > 0) {
                    var sortedSubSubPerm = sortBy(subSubPermission, "id");
                    subPerm.subPermissions = sortedSubSubPerm;
                }
            });
        }
        var sortedSubPerm = sortBy(subPermissions, "id");
        perm.subPermissions = sortedSubPerm;
        formattedPermissions.push(perm);
    });
    return formattedPermissions;
};
var ManageRoles = function (_a) {
    var authentication = _a.authentication, onCloseClick = _a.onCloseClick, onRoleChanges = _a.onRoleChanges;
    var _b = useState(), onload = _b[0], setOnload = _b[1];
    var _c = useState(), localRolesData = _c[0], updateLocalRolesData = _c[1];
    var _d = useState(0), activeRoleIndex = _d[0], updateActiveRoleIndex = _d[1];
    var _e = useState(), staticPermissions = _e[0], updateStaticPermissions = _e[1];
    var _f = useState(), userPermissions = _f[0], updateUserPermissions = _f[1];
    var _g = useState(), selectedRoleData = _g[0], updateSelectedRoleData = _g[1];
    var _h = useState(false), isloading = _h[0], toggleLoading = _h[1];
    useEffect(function () {
        toggleLoading(true);
        DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
            var _a;
            setOnload(onload);
            fetchUserPermissions((_a = onload === null || onload === void 0 ? void 0 : onload.user) === null || _a === void 0 ? void 0 : _a.id);
            fetchRolesData(-1);
        }).catch(function () {
            toggleLoading(false);
        });
    }, [authentication.selectedBrand]);
    var permRef = useRef();
    var clearSelectedPermissions = function () {
        var _a;
        if (permRef === null || permRef === void 0 ? void 0 : permRef.current)
            (_a = permRef === null || permRef === void 0 ? void 0 : permRef.current) === null || _a === void 0 ? void 0 : _a.resetSelectedPermissions();
    };
    var roleUsersRef = useRef();
    var onRoleIndexUpdate = function (index) {
        var _a;
        if (activeRoleIndex !== index) {
            updateActiveRoleIndex(index);
            updateSelectedRoleData(localRolesData === null || localRolesData === void 0 ? void 0 : localRolesData[index]);
            fetchSelectedRoleData(localRolesData[index].id);
            clearSelectedPermissions();
            if (roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current)
                (_a = roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current) === null || _a === void 0 ? void 0 : _a.resetStates();
        }
    };
    var fetchRolesData = function (roleId) {
        toggleLoading(true);
        DataUtils.role(authentication).getAll().then(function (roles) {
            if (roles && Array.isArray(roles)) {
                updateLocalRolesData(roles);
                if (!staticPermissions)
                    fetchPermissionsData(roles);
                else {
                    var activeIndex = activeRoleIndex;
                    if (roleId > -1) {
                        activeIndex = findIndex(roles, function (obj) { return obj.id === roleId; });
                        RoleGroupUtils.scrollToRole("rl-" + roleId, "rl-cntnr-list");
                    }
                    if (activeIndex < 0 || activeIndex >= (roles === null || roles === void 0 ? void 0 : roles.length)) {
                        activeIndex = (roles === null || roles === void 0 ? void 0 : roles.length) - 1;
                    }
                    updateActiveRoleIndex(activeIndex);
                    fetchSelectedRoleData(roles === null || roles === void 0 ? void 0 : roles[activeIndex].id);
                }
            }
        }).catch(function () {
            toggleLoading(false);
        });
    };
    var addRole = function (roleName) {
        var newRoleName = roleName || "New role";
        var roleNames = RoleGroupUtils.getAllNames(localRolesData);
        newRoleName = RoleGroupUtils.getNewName(roleNames, newRoleName);
        if (!newRoleName)
            return;
        toggleLoading(true);
        DataUtils.role(authentication).create({ id: 0, name: newRoleName }).then(function (role) {
            var newRoleId = role === null || role === void 0 ? void 0 : role.id;
            fetchRolesData(newRoleId);
            if (onRoleChanges)
                onRoleChanges();
        }).catch(function (err) {
            var _a, _b;
            toggleLoading(false);
            // message.warning(err?.response?.data?.message)
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
        }).finally(function () {
            AmplitudeEventsUtils.manageRoleAddRole('NEW', newRoleName);
        });
    };
    var deleteRole = function (roleId) {
        if (!roleId)
            return;
        toggleLoading(true);
        DataUtils.role(authentication).delete(roleId).then(function (role) {
            var _a;
            fetchRolesData(-1);
            if (roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current)
                (_a = roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current) === null || _a === void 0 ? void 0 : _a.fetchUsers();
            if (onRoleChanges)
                onRoleChanges();
        }).catch(function (err) {
            var _a, _b;
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
            toggleLoading(false);
        });
    };
    var duplicateRole = function (activeRoleDetails) {
        if (!activeRoleDetails)
            return;
        var roleName = activeRoleDetails === null || activeRoleDetails === void 0 ? void 0 : activeRoleDetails.name;
        var roleNames = RoleGroupUtils.getAllNames(localRolesData);
        var newRoleName = RoleGroupUtils.getNewName(roleNames, roleName);
        if (!newRoleName)
            return;
        toggleLoading(true);
        DataUtils.role(authentication).create({ id: 0, name: newRoleName }).then(function (role) {
            var newRoleId = role === null || role === void 0 ? void 0 : role.id;
            makeChangesToRole(newRoleId, [], activeRoleDetails === null || activeRoleDetails === void 0 ? void 0 : activeRoleDetails.permissions);
            fetchRolesData(newRoleId);
        }).catch(function (err) {
            var _a, _b;
            // message.warning(err?.response?.data?.message);
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
            toggleLoading(false);
        }).finally(function () {
            AmplitudeEventsUtils.manageRoleAddRole('DUPLICATE', newRoleName);
        });
    };
    var fetchUserPermissions = function (userId) {
        DataUtils.permission(authentication).get(userId).then(function (userPermission) {
            var formattedPermissions = convertArrayToObject(userPermission, "id");
            updateUserPermissions(formattedPermissions);
        });
    };
    var fetchPermissionsData = function (rolesData) {
        toggleLoading(true);
        DataUtils.permission(authentication).getAll().then(function (permissions) {
            var _a;
            updateStaticPermissions(processStaticPermissions(cloneDeep(permissions)));
            if (rolesData && Array.isArray(rolesData)) {
                var activeIndex = activeRoleIndex;
                if (activeIndex >= rolesData.length) {
                    activeIndex = rolesData.length - 1;
                    updateActiveRoleIndex(activeIndex);
                }
                fetchSelectedRoleData((_a = rolesData === null || rolesData === void 0 ? void 0 : rolesData[activeIndex]) === null || _a === void 0 ? void 0 : _a.id);
            }
            else
                toggleLoading(false);
        }).catch(function () {
            toggleLoading(false);
        });
    };
    var fetchSelectedRoleData = function (roleId, roleData) {
        if (roleData) {
            updateSelectedRoleData(roleData);
        }
        else {
            toggleLoading(true);
            DataUtils.role(authentication).get(roleId).then(function (role) {
                updateSelectedRoleData(role);
            }).finally(function () {
                toggleLoading(false);
            });
        }
    };
    var makeChangesToRole = function (roleId, userList, permissions, fetchUserList) {
        toggleLoading(true);
        DataUtils.role(authentication).update(roleId, {
            permissions: permissions,
            users: userList
        }).then((function (role) {
            var _a;
            fetchSelectedRoleData(roleId, role);
            if (fetchUserList && (roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current))
                (_a = roleUsersRef === null || roleUsersRef === void 0 ? void 0 : roleUsersRef.current) === null || _a === void 0 ? void 0 : _a.fetchUsers();
            if (onRoleChanges)
                onRoleChanges();
        })).catch(function (err) {
            // message.warning(err?.response?.data?.message)
            NotificationUtils.warning("Unable to complete this request", "Please try again later", "ghost");
            clearSelectedPermissions();
        }).finally(function () {
            toggleLoading(false);
        });
    };
    var renameRole = function (roleId, newRoleName) {
        toggleLoading(true);
        DataUtils.role(authentication).rename({
            id: roleId,
            name: newRoleName
        }).then((function (role) {
            fetchRolesData(roleId);
            if (onRoleChanges)
                onRoleChanges();
        })).catch(function (err) {
            var _a, _b;
            // message.warning(err?.response?.data?.message)
            NotificationUtils.warning("Request failed.", (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost");
            clearSelectedPermissions();
            toggleLoading(false);
        }).finally(function () {
            AmplitudeEventsUtils.manageRoleRenameRole(newRoleName);
        });
    };
    return React.createElement(Spin, { spinning: isloading, size: "large", indicator: React.createElement(Icon, { type: "loading", spin: true }) },
        React.createElement(React.Fragment, null,
            React.createElement(Row, { style: { height: "100%", width: "100%" }, className: "mng-roles-container" },
                React.createElement(Col, __assign({}, breakpoints, { className: "mng-roles-col brdr-rgt" }),
                    React.createElement(Roles, { authentication: authentication, onRoleIndexUpdate: onRoleIndexUpdate, handleRoleAddition: addRole, handleRoleDeletion: deleteRole, handleRoleRename: renameRole, handleRoleDuplication: duplicateRole, activeRoleIndex: activeRoleIndex, rolesData: localRolesData, selectedRoleData: selectedRoleData, onload: onload })),
                React.createElement(Col, __assign({}, breakpoints, { className: "mng-roles-col brdr-rgt" }),
                    React.createElement(RolePermissions, { ref: permRef, authentication: authentication, activeRoleIndex: activeRoleIndex, selectedRoleData: selectedRoleData, staticPermissions: staticPermissions, userPermissions: userPermissions, updateRoleDetails: makeChangesToRole, onload: onload })),
                React.createElement(Col, __assign({}, breakpoints, { className: "mng-roles-col" }),
                    React.createElement(RoleUsers, { ref: roleUsersRef, authentication: authentication, selectedRoleData: selectedRoleData, updateRoleDetails: makeChangesToRole, onload: onload })))));
};
export default ManageRoles;
//# sourceMappingURL=index.js.map